<nb-card
  [ngClass]="{
    'dialog-full': size == 'full',
    'dialog-wide': size == 'wide',
    'dialog-half': size == 'half',
    'fit-content': fit,
    'full-height': fullHeight,
    'full-view': fullView
  }"
>
  <nb-card-header *ngIf="title || showCloseButton || showCollapseButton"
    ><h2 *ngIf="title">{{ title }}</h2>

    <button
      *ngIf="showCloseButton || showCollapseButton"
      (click)="handleClose()"
      class="scaffold-dialog-close-button"
      nbButton
      ghost
    >
      <nb-icon
        *ngIf="showCollapseButton"
        style="font-size: 13px"
        pack="fas"
        icon="down-left-and-up-right-to-center"
      ></nb-icon>
      <i
        style="font-size: 13px"
        *ngIf="showCloseButton"
        class="fa-thin fa-xmark"
      ></i>
    </button>
  </nb-card-header>
  <nb-card-body>
    <ng-content select="[scaffoldDialogBody]"></ng-content>
  </nb-card-body>
  <nb-card-footer [ngClass]="{ 'flex-end': buttonsFlexEnd }">
    <ng-content
      class="footer-buttons"
      select="[scaffoldDialogButtons]"
    ></ng-content>
  </nb-card-footer>
</nb-card>
